import { HotelOfferDetail, HotelRoomsDetail } from "shared/types/hotels";

import * as actionTypes from "../actions/actionTypes";

export type returnType = {
  hotelOfferDetail: HotelOfferDetail;
  currency: string;
  hotelRoomsDetail: HotelRoomsDetail;
  travelPoliciesResult: any;
  travelPolicies: any;
};

interface HotelsState {
  oHotelOffers: Record<string, HotelOfferDetail> | {};
  aHotelOffers: string[] | [];
  hotelRooms: Record<string, HotelRoomsDetail> | {};
  imageGalleryHotelIndicator: string | null;
  imageGalleryIndex: number;
  travelPolicies: any[];
  travelPoliciesResults: any[];
  travelPoliciesRooms: any[];
  travelPoliciesRoomsResults: any[];
  searchHotelRoomsQuery: string;
  map: {
    selectedMapLocationTo: { lat: number; lng: number } | null;
    selectedMapLocationFrom: string;
    lastOptions: any[];
  };
}

const initState: HotelsState = {
  oHotelOffers: {},
  aHotelOffers: [],
  hotelRooms: {},
  imageGalleryHotelIndicator: null,
  imageGalleryIndex: 0,
  travelPolicies: [],
  travelPoliciesResults: [],
  travelPoliciesRooms: [],
  travelPoliciesRoomsResults: [],
  searchHotelRoomsQuery: "",
  map: {
    selectedMapLocationTo: null,
    selectedMapLocationFrom: "",
    lastOptions: [],
  },
};

const reducer = (state = initState, action: any): HotelsState => {
  switch (action.type) {
    case actionTypes.SET_HOTELS_VALUE:
      return { ...state, [action.data.name]: action.data.value };

    case actionTypes.SET_HOTEL_ROOMS_VALUE:
      return {
        ...state,
        hotelRooms: {
          ...state.hotelRooms,
          [action.data.name]: action.data.value,
        },
      };

    case actionTypes.SET_MAP_LOCATION_TO:
      return {
        ...state,
        map: {
          ...state.map,
          selectedMapLocationTo: action.data,
        },
      };

    case actionTypes.SET_MAP_LOCATION_FROM:
      return {
        ...state,
        map: {
          ...state.map,
          selectedMapLocationFrom: action.data,
        },
      };

    case actionTypes.SET_MAP_LAST_OPTIONS:
      return {
        ...state,
        map: {
          ...state.map,
          lastOptions: action.data,
        },
      };

    default:
      return state;
  }
};

export default reducer;
